import router from "../router";
import {gameItemEnumToString} from "./EnumTransition";

/**
 * 统一处理  论文分配 论文终审  审稿 的结果
 * @param result
 * @param vue
 * @returns {*}
 */
export function disposeResult(result,vue) {
  if (result.length === 0) {
    return
  }

  vue.hideColumn()
  let number = router.app.$options.store.state.curRound
  if (number === 1) {
    vue.oneColumn = true
  } else if (number === 2) {
    vue.twoColumn = true
  } else if (number === 3) {
    vue.threeColumn = true
  }
  for (let i = 0; i < result.length; i++) {
    result[i].isFinal = "未终审"
    for (let p = 0; p < result[i].refereeOpinionVos.length; p++) {
      if (result[i].refereeOpinionVos[p].isFinal === 1 && result[i].refereeOpinionVos[p].roundNo ===number ) {
        result[i].isFinal = "已终审"
        break
      }
    }
    let splits = result[i].chKeyWords.split(",")
    let splits1 = result[i].enKeyWords.split(",")
    let chKeyWords = ""
    for (let i = 0; i < splits.length; i++) {
      if (splits[i].trim() === "") {
        continue
      } else {
        chKeyWords += splits[i] + ","
      }
    }
    let enKeyWords = ""
    for (let j = 0; j < splits1.length; j++) {
      if (splits1[j].trim() === "") {
        continue
      } else {
        enKeyWords += splits1[j] + ","
      }
    }
    chKeyWords = chKeyWords.substring(0, chKeyWords.lastIndexOf(","));
    enKeyWords = enKeyWords.substring(0, enKeyWords.lastIndexOf(","));
    result[i].chKeyWords = chKeyWords + "\r\n" + "(" + enKeyWords + ")"
    result[i].gameItem = gameItemEnumToString(result[i].gameItem)
    result[i].chName = result[i].chName + "(" + result[i].enName + ")"
    let teacherName = ""
    if (result[i].teacherInfos.length === 1) {
      teacherName = result[i].teacherInfos[0].teacherName
    } else {
      teacherName = result[i].teacherInfos[0].teacherName + "," + result[i].teacherInfos[1].teacherName
    }
    result[i].teacherName = teacherName

    let currentData = []
    let refereeTrueName = ""
    for (let j = 0; j < result[i].refereeOpinionVos.length; j++) {
      if (result[i].refereeOpinionVos[j].roundNo === number) {
        currentData.push(result[i].refereeOpinionVos[j])
      }
    }
    for (let p = 0; p < currentData.length; p++) {
      if (p === currentData.length - 1) {
        refereeTrueName += currentData[p].refereeTrueName
      } else {
        refereeTrueName += currentData[p].refereeTrueName + ","
      }
    }
    result[i].refereeTrueName = refereeTrueName
  }
  return result
}



// WEBPACK FOOTER //
// ./src/util/DisposeResult.js